'use client';

import {NavigationProvider} from '@/contexts/NavigationContext';
import HeaderWrapper from './HeaderWrapper';
import {ReactNode} from 'react';

interface ClientAppShellProps {
    children: ReactNode;
}

/**
 * ClientAppShell wraps the app in NavigationProvider and renders the header and children.
 * Use this in the root layout to keep SSR for the rest of the app.
 */
export default function ClientAppShell({children}: ClientAppShellProps) {
    return (
        <NavigationProvider>
            <HeaderWrapper/>
            {children}
        </NavigationProvider>
    );
}
